<template>
  <div id="header">
    <div id="header-container">
      <router-link :class="{'mobile': $route.path !== '/'}" class="header-logo" to="/" @click.native="clickLogo">
        <img alt="青草窠" :src="titleLogo"/>
      </router-link>
      <div id="header-menu">
        <header>
          <transition name="slide">
            <MenuSp v-if="isMenuOpen" :links="links" @closeMenu="isMenuOpen = false"/>
          </transition>
          <transition name="fade">
            <ul v-if="showHeader" id="menu-items" :class="{'is-open': isMenuOpen, 'en': $i18n.locale === 'en'}">
              <template v-for="(link, index) of links">
                <li v-if="!link.hideOnTop" :class="{'active': ($route.path === '/' || $route.name === link.to.name)}" :key="index">
                  <router-link @click.native="handleLinkValue(link.to)" :to="link.to">{{ $t(link.title) }}</router-link>
                </li>
              </template>
            </ul>
          </transition>
          <div class="locale">
            <a @click="changeLocale('ja')" :class="{'active': $i18n.locale !== 'ja'}">JA</a>
            |
            <a @click="changeLocale('en')" :class="{'active': $i18n.locale !== 'en'}">EN</a>
          </div>
          <Hamburger class="hamburger" v-model="isMenuOpen"/>
        </header>
      </div>
    </div>
  </div>
</template>

<script>
import logo from "@/assets/logo/logo.svg";

import MenuSp from "@/components/Menu/MenuSp.vue";
import Hamburger from "@/components/Menu/Hamburger.vue";

export default {
  components: {
    MenuSp,
    Hamburger,
  },
  data:() => ({
    scrollY: 0,
    showHeaderTimeoutObject: null,
    showHeader: false,
    isMenuOpen: false,
    scrollPos: 0,
    links: [
      {
        title: "top",
        to: { name: "Home" },
        hideOnTop: true,
      },
      {
        title: "greeting",
        to: { name: "Greeting" },
      },
      {
        title: "about",
        to: { name: "About" },
      },
      {
        title: "info",
        to: { name: "Info" },
      },
      {
        title: "news",
        to: { name: "Home", params: { value: "news" }},
      },
    ]
  }),
  computed: {
    titleLogo() {
      return logo;
    },
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll);
    window.addEventListener('mousemove', this.handleMousemove);
  },
  methods: {
    clickLogo() {
      window.scrollTo({
        top: 0,
        behavior: "smooth"
      });
    },
    handleLinkValue(to) {
      if (this.$route.path === "/" && to.params && to.params.value === "news") {
        window.scrollTo({
          top: document.getElementById("news").offsetTop,
          behavior: "smooth"
        });
      }
    },
    handleScroll() {
      // fade out header after not scrolling for 5 seconds
      const currentScrollY = window.scrollY;
      if (currentScrollY !== this.scrollY) {
        clearTimeout(this.showHeaderTimeoutObject);
        this.showHeader = true;
        // this.showHeaderTimeoutObject = setTimeout(() => {
        //   this.showHeader = false;
        // }, 5000);
      }
      this.scrollY = currentScrollY;
    },
    handleMousemove() {
      // fade out header after no mousemove for 5 seconds
      clearTimeout(this.showHeaderTimeoutObject);
      this.showHeader = true;
      // this.showHeaderTimeoutObject = setTimeout(() => {
      //   this.showHeader = false;
      // }, 5000);
    },
    changeLocale(lang) {
      this.$i18n.locale = lang;
    },
  },
}
</script>

<style lang="scss" scoped>
#header-container {
  position: relative;
  margin-left: auto;
  margin-right: auto;
  max-width: 360px;
}

#header-menu {
  z-index: 9;
  position: fixed;
  top: 0;
  width: 100%;
}

.header-logo {
  z-index: 10;
  top: 0;
  left: 0;
  display: inline-block;
  margin: 30px 21px;
  img {
    height: 57px;
  }
}

.mobile {
  display: none;
}

#menu-items {
  display: none;
}

.locale {
  > a {
    cursor: pointer;
    margin: 0 3px;
    color: #a7a7a7;
    &.active {
      color: #000000;
    }
  }
  @media (max-width: $pc-menu-vw - 1) {
    position: fixed;
    right: 70px;
    top: 16px;
    width: 80px;
    height: 30px;
    padding: 6px;
  }
  @media (min-width: $pc-menu-vw) {
    position: relative;
    margin: 10px 34px 0 0;
    padding: 28px 23px 28px 0px;
  }
}

@media (min-width: $mobile-vw) {
  #header-container {
    max-width: $pc-vw;
  }

  .header-logo {
    position: absolute;
    margin: 55px;
    img {
      height: 75px;
    }
  }
}

@media (min-width: $pc-menu-vw) {
  header {
    display: flex;
    justify-content: flex-end;
    height: 80px;
    max-width: $pc-vw;
  }

  .hamburger {
    display: none;
  }

  .mobile {
    display: block;
  }

  #menu-items {
    list-style-type: none;
    display: flex;
    height: 100%;
    margin: 10px 10px 0 0;

    > li:not(.active) * {
      color: #a7a7a7;
    }
    > li {
      margin: 0 25px;
    }
    &.en li {
      margin: 0 15px
    }
    > li > * {
      display: flex;
      align-items: center;
      font-size: 15px;
      height: 100%;
    }
  }
}

.slide-enter-active, .slide-leave-active {
  transform: translate(0px);
  transition: transform .2s ease-in;
}

.slide-enter, .slide-leave-to {
  transform: translateX(100vw);
}

.fade-enter-active, .fade-leave-active {
  transition: opacity .3s ease-in;
}
.fade-enter, .fade-leave-to {
  opacity: 0
}
</style>